import { useEffect, useState } from "react";

/**
 * Calm, fixed-top banner shown when the backend is temporarily unreachable
 * (deploy rollover, pod restart, etc.). Auto-hides once requests succeed again.
 */
const ReconnectBanner = ({ active }) => {
  const [visible, setVisible] = useState(false);
  const [dots, setDots] = useState("");

  useEffect(() => {
    if (active) setVisible(true);
    else {
      // small delay so users see the "back online" flash
      const t = setTimeout(() => setVisible(false), 900);
      return () => clearTimeout(t);
    }
  }, [active]);

  useEffect(() => {
    if (!active) return;
    const i = setInterval(() => setDots((d) => (d.length >= 3 ? "" : d + ".")), 500);
    return () => clearInterval(i);
  }, [active]);

  if (!visible) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[100] pointer-events-none"
      data-testid="reconnect-banner"
    >
      <div
        className="mx-auto max-w-xl mt-2 rounded-full px-4 py-2 flex items-center justify-center gap-2 backdrop-blur-xl border shadow-lg pointer-events-auto"
        style={{
          background: active
            ? "linear-gradient(135deg, rgba(250,204,21,0.18), rgba(10,15,31,0.92))"
            : "linear-gradient(135deg, rgba(34,197,94,0.18), rgba(10,15,31,0.92))",
          borderColor: active ? "rgba(250,204,21,0.45)" : "rgba(34,197,94,0.45)",
        }}
      >
        {active ? (
          <>
            <span
              className="inline-block w-2 h-2 rounded-full animate-pulse"
              style={{ background: "#facc15" }}
            />
            <span className="text-xs font-semibold text-amber-200">
              Servers are busy{dots}
            </span>
            <span className="text-[10px] text-white/60 hidden sm:inline">
              · We're back in a few seconds — your spins are safe
            </span>
          </>
        ) : (
          <>
            <span
              className="inline-block w-2 h-2 rounded-full"
              style={{ background: "#22c55e" }}
            />
            <span className="text-xs font-semibold text-emerald-200">
              Back online
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default ReconnectBanner;
